import { app } from '../../../../../../app';
import { Controller } from './add-user.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectoryAddUser', {
    bindings: {
        companyId: '<',
        userAccountEmail: '<'
    },
    controller: Controller,
    templateUrl: require('./add-user.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/add-user/add-user.component.js